
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"667","height":"438","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M651.416 1.038H15.584c-8.033 0-14.545 6.506-14.545 14.53v406.863c0 8.025 6.512 14.531 14.545 14.531h635.832c8.033 0 14.545-6.506 14.545-14.531V15.569c0-8.025-6.512-14.531-14.545-14.531z","stroke":"#A5A8C1"}}),_c('path',{attrs:{"d":"M1.558 58.642H665.44","stroke":"#A5A8C1","stroke-linecap":"square"}}),_c('path',{attrs:{"d":"M28.571 34.251a4.673 4.673 0 004.675-4.67c0-2.58-2.093-4.671-4.675-4.671a4.673 4.673 0 00-4.675 4.67c0 2.58 2.093 4.671 4.675 4.671zM50.39 34.251a4.673 4.673 0 004.674-4.67c0-2.58-2.093-4.671-4.675-4.671a4.673 4.673 0 00-4.675 4.67c0 2.58 2.093 4.671 4.675 4.671zM71.168 34.251a4.673 4.673 0 004.675-4.67c0-2.58-2.093-4.671-4.675-4.671a4.673 4.673 0 00-4.675 4.67c0 2.58 2.093 4.671 4.675 4.671z","fill":"#A5A8C1"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.078 59.161h662.844v363.27c0 7.452-6.047 13.493-13.506 13.493H15.584c-7.459 0-13.506-6.041-13.506-13.493V59.161z","fill":"#A5A8C1","stroke":"#979797"}})])
          )
        }
      }
    